module.exports = __webpack_public_path__ + "img/p-14.eb2d69a0.webp";